import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const SellerLevel = ({level, isPro, isLimitedEdition}) => {
    const sellerLevelProps = {
        className: 'gig-seller-tooltip'
    };

    let levelText = '';

    if (isLimitedEdition) {
        level = 'pro_spotlight_seller';
    }

    switch (level) {
        case 'level_one_seller':
        case 'level_two_seller':
        case 'pro_spotlight_seller':
            levelText = i18n.t(`general.seller_levels.${level}`);
            levelText += ' Seller';
            break;
        case 'top_rated_seller':
            levelText = i18n.t(`index.levels.${level}`);
            levelText = <em>{levelText}</em>;
            break;
        default:
            levelText = i18n.t(isPro ? 'advanced_search.filters.seller_level_options.na_pro' : 'advanced_search.filters.seller_level_options.na');
            break;
    }

    if (level) {
        sellerLevelProps.className += ' badge-hint js-badge-hint';
        sellerLevelProps['data-hint'] = i18n.t(`index.levels.${level}_tooltip`);
    }

    return (
        <div {...sellerLevelProps}>
            <span className="seller-level">{levelText}</span>
        </div>
    );
};

SellerLevel.propTypes = {
    level: PropTypes.string
};

export default SellerLevel;



// WEBPACK FOOTER //
// ./src/shared/seller_level/index.js